import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { CacheState } from './types'
import { RootState } from '../../types'

export const state: CacheState = {
  cache: null
}

const namespaced = true

export const cache: Module<CacheState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
